import {
  Box,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import RootComponents from "../../../components/common/RootComponents";
import styles from "../InternalTracker.module.css";
import { customTextColor } from "../../../utils/const";
import TableCard from "../../../components/common/TableCard";
import InternalTrackerTable from "./InternalTrackerTable";
import { IoIosAdd } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchInternalSubmission from "./SearchInternalTracker";
import {
  getAllInternalCandidateCard,
  getTrackerDetails,
} from "../../../redux/internal-tracking/InternalTrackerSlice";
import { useDispatch, useSelector } from "react-redux";
import TableCardNew from "../../../components/common/TableCardNew";
import { BsFileEarmarkText, BsFillJournalBookmarkFill } from "react-icons/bs";
import { PiChatsFill } from "react-icons/pi";
import { GoChecklist } from "react-icons/go";
import { LiaHeadsetSolid } from "react-icons/lia";
import { Icon } from "@iconify/react/dist/iconify.js";

const InternalTracker = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [internalTrack, setInternalTrack] = useState([]);
  const [internalTrackList, setInternalTrackList] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);

  const [searchData, setSearchData] = useState({
    prefer_tax_term: [],
    work_authorization: [],
    work_preference: [],
    skill: [],
    location: [],
    rate: "",
    domain_name: "",
    updated_at: "",
    job_profile: [],
    consultant_name: "",
    // filter_for: "both",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const trackDetails = useSelector((state) => state.tracker);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const internalCard = useSelector((state) => state.tracker.cardData);
  const internalStatus = useSelector((state) => state.tracker.status);
  const cardDataStatus = useSelector((state) => state.tracker.cardDataStatus);

  console.log({ internalCard });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let queryString = `page=${page}&page_size=${rowsPerPage}`;
    dispatch(getTrackerDetails(queryString));
  }, [page, rowsPerPage]);

  useEffect(() => {
    dispatch(getAllInternalCandidateCard());
  }, []);

  useEffect(() => {
    if (trackDetails) {
      const combinedCandidates = [
        ...(trackDetails?.data?.data || []),
        ...(trackDetails?.data?.data || []),
      ];
      setInternalTrack(trackDetails?.data?.results?.data);
      setInternalTrackList(trackDetails?.data?.results?.data);
    }
  }, [trackDetails]);

  const handleOnClear = () => {
    setSearchData({
      prefer_tax_term: [],
      work_authorization: [],
      location: [],
      // filter_for: "both",
      consultant_name: "",
      job_profile: [],
    });
  };

  useEffect(() => {
    if (internalTrackList) {
      const jobTitle = internalTrackList
        ?.map((requirement) => requirement.current_job_title)
        .filter(
          (title, index, self) => title && self?.indexOf(title) === index
        ); // Remove duplicates and nulls
      setJobTitles(jobTitle);
    }
  }, [internalTrackList]);

  useEffect(() => {
    if (searchData) {
      const queryParams = Object.keys(searchData).reduce((acc, key) => {
        const value = searchData[key];
        console.log({ value });

        if (Array.isArray(value) && value.length > 0) {
          // Send arrays as JSON strings
          acc[key] = JSON.stringify(value);
        } else if (
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !Array.isArray(value)
        ) {
          // Include non-empty strings or numbers
          acc[key] = value;
        }
        return acc;
      }, {});

      console.log("Filtered Query Params:", queryParams);

      // Convert queryParams into a query string
      const queryString = Object.entries(queryParams)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      console.log("Final Query String:", queryString);
      let quiry = `${queryString}&page=${page}&page_size=${rowsPerPage}`;
      // Dispatch the action with the query string
      dispatch(getTrackerDetails(quiry));
    } else {
      let queryString = `page=${page}&page_size=${rowsPerPage}`;
      dispatch(getTrackerDetails(queryString));
    }
  }, [searchData, dispatch]);

  return (
    // <RootComponents>
    <>
      <Box className={styles.internal_tracker_structure}>
        {/* <Box className={styles.internal_tracker_heading}>
          <Typography sx={{ color: customTextColor }}>
            Internal Candidates Tracker
          </Typography>
          <button onClick={() => navigate("/internal-tracker-add")}>
            Consultant
            <IoIosAdd style={{ fontSize: "25px" }} />
          </button>
        </Box> */}
        {/* <Box
          sx={{
            padding: "10px 0 5px 0 ",
            backgroundColor: "#fff",
            marginBottom: "14px",
          }}
        >
          <Grid container>
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                count={
                  internalCard?.internal_candidates !== null
                    ? internalCard?.internal_candidates
                    : 0
                }
                text="Internal Candidates "
                customStyle="10px 10px 0 15px; background-color: white;"
                loading={cardDataStatus}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                count={
                  internalCard?.private_candidates !== null
                    ? internalCard?.private_candidates
                    : 0
                }
                text="Private Candidates "
                customStyle={{ backgroundColor: "white" }}
                loading={cardDataStatus}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                count={
                  internalCard?.contract !== undefined &&
                  internalCard?.Contract !== undefined
                    ? internalCard.contract +
                      internalCard.Contract +
                      (internalCard?.contract_to_hire !== undefined
                        ? internalCard.contract_to_hire
                        : 0)
                    : internalCard?.contract !== undefined
                    ? internalCard.contract +
                      (internalCard?.contract_to_hire !== undefined
                        ? internalCard.contract_to_hire
                        : 0)
                    : internalCard?.Contract !== undefined
                    ? internalCard.Contract +
                      (internalCard?.contract_to_hire !== undefined
                        ? internalCard.contract_to_hire
                        : 0)
                    : internalCard?.contract_to_hire !== undefined
                    ? internalCard.contract_to_hire
                    : 0
                }
                text="Contract Candidates"
                customStyle={{ backgroundColor: "white" }}
                loading={cardDataStatus}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                count={
                  internalCard?.full_Time !== null &&
                  internalCard?.full_Time !== undefined
                    ? internalCard?.full_Time
                    : 0
                }
                text="Full Time Candidates"
                customStyle={{ backgroundColor: "white" }}
                loading={cardDataStatus}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                count={
                  internalCard?.w2_with_benefit !== undefined &&
                  internalCard?.w2_without_benefit !== undefined
                    ? internalCard.w2_with_benefit +
                      internalCard.w2_without_benefit
                    : internalCard?.w2_with_benefit !== undefined
                    ? internalCard.w2_with_benefit
                    : internalCard?.w2_without_benefit !== undefined
                    ? internalCard.w2_without_benefit
                    : 0
                }
                text="W2 Candidates"
                customStyle="10px 16px 0 5px; background-color: white;"
                loading={cardDataStatus}
              />
            </Grid>
          </Grid>
          <Box sx={{ marginTop: "20px" }}>
            <SearchInternalSubmission
              handleOnClear={handleOnClear}
              jobTitles={jobTitles}
              trackDetails={trackDetails}
              setSearchData={setSearchData}
              searchData={searchData}
            />
          </Box>
        </Box> */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: "white",
            px: 1.5,
            mb: 1.5,
          }}
        >
          <Grid container gap={1.3}>
            <Grid item xs={12} sm={6} md={2.1}>
              <TableCardNew
                image={<Icon icon="mage:user-plus" className="card_icons" />}
                count={
                  internalCard?.internal_candidates !== null
                    ? internalCard?.internal_candidates
                    : 0
                }
                text="Internal Candidates"
                // customStyle="10px 10px 0 10px; background-color: white;"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.1}>
              <TableCardNew
                image={
                  <Icon icon="hugeicons:shield-user" className="card_icons" />
                }
                count={
                  internalCard?.private_candidates !== null
                    ? internalCard?.private_candidates
                    : 0
                }
                text="Private Candidates"
                customStyle={{ backgroundColor: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2.1}>
              <TableCardNew
                image={
                  <Icon
                    icon="icon-park-outline:add-user"
                    className="card_icons"
                    style={{ fontSize: "25px" }}
                  />
                }
                count={
                  internalCard?.contract_count !== null
                    ? internalCard?.contract_count
                    : 0
                }
                text="Contract Candidates"
                // customStyle={{ backgroundColor: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2.1}>
              <TableCardNew
                image={<Icon icon="ph:user-list" className="card_icons" />}
                count={
                  internalCard?.full_time_count !== null
                    ? internalCard?.full_time_count
                    : 0
                }
                text="Full Time Candidates"
                // customStyle={{ backgroundColor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.1}>
              <TableCardNew
                image={
                  <Icon
                    icon="tabler:user-screen"
                    className="card_icons"
                    style={{ fontSize: "25px" }}
                  />
                }
                count={
                  internalCard?.w2_with_benefit_count !== null
                    ? internalCard?.w2_with_benefit_count
                    : 0
                }
                text="W2 Candidates"
                customStyle="10px 16px 0 5px; background-color: white;"
              />
            </Grid>
          </Grid>
          <button
            onClick={() => {
              navigate("/internal-tracker-add");

              localStorage.setItem(
                "internalTrackerCandidateAddOrUpdate",
                JSON.stringify({
                  row: undefined,
                  types: "add",
                })
              );
            }}
            className={styles.internal_tracker_heading_btn}
          >
            Candidate
            <IoIosAdd style={{ fontSize: "25px" }} />
          </button>
        </Box>
        {/* <Box sx={{ marginTop: "20px" }}> */}
        <SearchInternalSubmission
          handleOnClear={handleOnClear}
          jobTitles={jobTitles}
          trackDetails={trackDetails}
          setSearchData={setSearchData}
          searchData={searchData}
        />
        {/* </Box> */}

        <InternalTrackerTable
          internalTrack={internalTrack}
          trackDetails={trackDetails}
          setPage={setPage}
          page={page}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        />
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogContent sx={{ backgroundColor: "#f2f2f2" }}>
          <Box className={styles.feedback_listing_details}>
            <Typography>
              <b>100% free Candidate Tracking</b>
            </Typography>
          </Box>
          <Box className={styles.tracker_details}>
            <span>
              <Typography>
                <b>Simple track your candidate for next requirement.</b>
              </Typography>
              <Typography>Get it by advance search.</Typography>
            </span>

            <span>
              <button onClick={() => navigate("/internal-tracker-add")}>
                Add Now
              </button>
            </span>
          </Box>
        </DialogContent>
      </Dialog>
    </>
    // </RootComponents>
  );
};

export default InternalTracker;
